import axios from "axios";
import { store } from "../../App";
import { convertCurrency } from "./dollarPricesAction";

export const addBalanceToUser = async (currentUser, balance, user) => {
  try {
    const currentAdmin = store.getState().authentication.user;
    const currentCenterId = JSON.parse(
      localStorage.getItem("centerId")
    ).centerId;
    const cafeOrder = {
      balanceId: balance._id,
      type: 1,
      name: balance.name,
      iqd: balance.value,
      price: convertCurrency(balance.value, "USD"),
      userId: currentUser._id,
      adminId: currentAdmin._id,
      bioStarID: currentUser.bioStarID,
      centerId: currentCenterId,
      paymentDetails: balance.paymentDetails.paymentDetails
    };
    await axios.post("/orders/make-order", { balance, cafeOrder, user: currentUser });
  } catch (e) {
    throw e;
  }
};

export const fetchBalances = async (data) => {
  try {
    const res = await axios.get(`/balances`);
    store.dispatch({ type: "FETCH_BALANCES", data: res.data });
  } catch (e) {
    console.log(e);
    throw e;
  }
};
